module.exports = __webpack_public_path__ + "img/logo-poltekes-small.f20fd45e.png";